import { AcademicCapIcon } from '@heroicons/react/24/solid';

export function LoadingScreen() {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-white">
      {/* Replaced Icon with PNG to match the logo style */}
      <img 
        src="/favicon.png" 
        alt="Loading..." 
        className="h-14 w-14 object-contain float-anim" 
      />
      
      {/* Applied the exact logo gradient to match your brand identity */}
      <span className="mt-4 font-serif text-2xl font-bold tracking-tight bg-gradient-to-br from-[#43a074] via-[#3ba696] to-[#87a9d6] bg-clip-text text-transparent">
        Learn
      </span>
    </div>
  );
}